import Swiper, { Navigation } from 'swiper'

export const init = async function () {
  // configure Swiper to use modules
  Swiper.use([Navigation])

  const swiper = new Swiper('.js-homepage-carousel2', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    // Enable lazy loading
    lazy: {
      loadPrevNext: true
    },
    loop: true,
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 40,
    breakpoints: {
      1024: {
        slidesPerView: 'auto',
        spaceBetween: 24,
        autoHeight: true
      }
    }
  })

  swiper.on('slideChangeTransitionEnd', (self) => {
    self.update()
  })
}
